import React from "react";
import StaticPageLayout, { useWeavevoI18n } from "./StaticPageLayout";

const I18N = {
  en: {
    title: "Blog / News",
    intro:
      "This page can be used to announce updates, events, or publish articles.",
    h1: "Latest news",
    li1: "[Date] — Launch of the public “Discover” page",
    li2: "[Date] — Improved Pinterest-style layout",
    li3: "[Date] — New montage / export system",
    note:
      "TODO: connect this page to an API (Markdown, CMS, or a simple database table).",
  },
  fr: {
    title: "Blog / Actualités",
    intro:
      "Cette page peut servir à annoncer les mises à jour, événements, ou publier des articles.",
    h1: "Dernières actualités",
    li1: "[Date] — Lancement de la page « Découvrir » (public)",
    li2: "[Date] — Amélioration de l’affichage type Pinterest",
    li3: "[Date] — Nouveau système de montage / export",
    note:
      "TODO : brancher cette page à une API (Markdown, CMS, ou simple table en base).",
  },
};

export default function Blog() {
  const { t } = useWeavevoI18n(I18N);

  return (
    <StaticPageLayout title={t("title")}>
      <p>{t("intro")}</p>

      <h2>{t("h1")}</h2>
      <ul>
        <li><strong>{t("li1")}</strong></li>
        <li><strong>{t("li2")}</strong></li>
        <li><strong>{t("li3")}</strong></li>
      </ul>

      <p className="wv-static-note">{t("note")}</p>
    </StaticPageLayout>
  );
}
